module.exports = __webpack_public_path__ + "img/76.6a85cebb.png";